@if (isHomePage) {
  <main>
    <div class="header">
      <div class="container-fluid">
        <nav>
          <div class="menu">
            <a (click)="onContactClick()">تماس با ما</a>
            <a [routerLink]="'/Trust'">اعتماد به ما</a>
            <a [routerLink]="'/'">
                <img alt="" src="/images/ic_logo.png" width="40" loading="lazy">
            </a>
            <a [routerLink]="'/AboutUs'">درباره ما</a>
            <a href="https://baazar.ir/mag/" rel="noopener" target="_blank">مجله
              بازر</a>
          </div>

          <div class="menu-buttons">
            <a href="https://cafebazaar.ir/app/com.aminsft.baazar2" rel="noopener" target="_blank" title="دانلود اپ">دانلود
              اپ</a>
            <a href="https://web.baazar.ir/" rel="noopener" target="_blank" title="ورود / ثبت نام">ورود / ثبت نام</a>
          </div>
        </nav>
        <div class="header-container">
          <div>
            <div>{{ persianDate }}</div>
            <div class="circle-container">
              <div class="circle-wrapper second">
                <div [style.stroke-dashoffset]="getStrokeDashoffset('second')" class="border-circle"></div>
                <div class="inner-circle">
                  <div class="number">{{ seconds }}</div>
                </div>
              </div>
              <div class="circle-wrapper minute">
                <div [style.stroke-dashoffset]="getStrokeDashoffset('minute')" class="border-circle"></div>
                <div class="inner-circle">
                  <div class="number">{{ minutes }}</div>
                </div>
              </div>
              <div class="circle-wrapper hour">
                <div [style.stroke-dashoffset]="getStrokeDashoffset('hour')" class="border-circle"></div>
                <div class="inner-circle">
                  <div class="number">{{ hours }}</div>
                </div>
              </div>
            </div>
            <div class="gold-price-numbers">
              <div>
                <div>قیمت خرید</div>
                <div>{{ integerAsCurrency(buyPrice) }} ریال</div>
                <div>

                  <a href="https://web.baazar.ir/" rel="noopener" target="_blank">میخوام بخرم</a>
                </div>
              </div>
              <div>
                <div>قیمت فروش</div>
                <div>{{ integerAsCurrency(sellPrice) }} ریال</div>
                <div>

                  <a href="https://web.baazar.ir/" rel="noopener" target="_blank">میخوام بفروشم</a>

                </div>
              </div>
            </div>
          </div>

          <div class="chart-container" style="height: 70%">
            <div class="dropdown-container">
              <a href="https://baazar.ir/chart/" rel="noopener" target="_blank">تحلیل تکنیکال</a>
              <select (change)="onChangePeriod($event)">
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="120">120</option>
                <option value="180">180</option>
                <option value="360">360</option>
              </select>
              <select (change)="onChangeInterval($event)">
                <option value="DAILY">روزانه</option>
                <option value="MONTHLY">ماهانه</option>
              </select>
            </div>
            <canvas height="200" id="lineChart" style="margin-top: 10%" width="400"></canvas>
          </div>

          <div>
              <img alt="gold picture" src="/images/gold-header-picture.png" loading="lazy">
          </div>
        </div>
      </div>
    </div>
  </main>
} @else {
  <main>
    <div class="header" style="height: 0">
      <div class="container-fluid">
        <nav>
          <div class="menu">
            <a (click)="onContactClick()">تماس با ما</a>
            <a [routerLink]="'/Trust'">اعتماد به ما</a>
            <a [routerLink]="'/'">
                <img alt="" src="/images/ic_logo.png" width="40" loading="lazy">
            </a>
            <a [routerLink]="'/AboutUs'">درباره ما</a>
            <a href="https://baazar.ir/mag/" rel="noopener" target="_blank">مجله
              بازر</a>
          </div>

          <div class="menu-buttons">
            <a href="https://cafebazaar.ir/app/com.aminsft.baazar2" rel="noopener" target="_blank" title="دانلود اپ">دانلود
              اپ</a>
            <a href="https://web.baazar.ir/" rel="noopener" target="_blank" title="ورود / ثبت نام">ورود / ثبت نام</a>
          </div>
        </nav>
      </div>
    </div>
  </main>
}

